import CashIcon from '../assets/img/cash.svg'
import MultiWithdraw from '../assets/img/pay_interest.svg'


export const CARD_FEATURE_DATA = [
    {
        id:"1",
        cardFeatureTitle: "Get cash for any business need and anytime",
        cardFeatureSummary: "Get instant cash with a click of a button from PayU dashboard with zero paperwork",
        cardFeatureIcon:<img src={CashIcon} alt=''/>
    },
    {
        id:"2",
        cardFeatureTitle: "One approval, multiple withdrawals",
        cardFeatureSummary: "Set-up your line of credit amount once and withdraw as per your need",
        cardFeatureIcon:<img src={MultiWithdraw} alt=''/>
    },
    {
        id:"3",
        cardFeatureTitle: "Flexible repayments",
        cardFeatureSummary: "Repay directly via settlements and set-up a mandate for any balance",
        cardFeatureIcon:<img src={CashIcon} alt=''/>
    },
    {
        id:"4",
        cardFeatureTitle: "Lowest interest rates",
        cardFeatureSummary: "Attractive interest rates, as low as 1.5% p.m. for up to 30 days 90 days",
        cardFeatureIcon:<img src={MultiWithdraw} alt=''/>
    },
    {
        id:"5",
        cardFeatureTitle: "Pay for what you use",
        cardFeatureSummary: "Pay interest only on the outstanding amount (Not for the entire withdrawal)",
        cardFeatureIcon:<img src={CashIcon} alt=''/>
    }
]